var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { AlertTriangle, CheckCircle, Info, XCircle } from 'lucide-react';
import { classNames as cn } from '../utils';
const alertVariants = cva('relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current', {
    variants: {
        variant: {
            default: 'bg-card text-card-foreground border-border',
            info: 'bg-brand-25 text-base-800 border-brand-200 [&>svg]:text-brand-500',
            success: 'bg-green-50 text-green-800 border-green-200 [&>svg]:text-green-600',
            warning: 'bg-amber-50 text-amber-800 border-amber-200 [&>svg]:text-amber-600',
            error: 'bg-red-50 text-red-800 border-red-200 [&>svg]:text-red-600',
            destructive: 'text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
const getDefaultIcon = (variant) => {
    switch (variant) {
        case 'info':
            return Info;
        case 'success':
            return CheckCircle;
        case 'warning':
            return AlertTriangle;
        case 'error':
            return XCircle;
        default:
            return null;
    }
};
export function Alert(_a) {
    var { className, variant, children } = _a, props = __rest(_a, ["className", "variant", "children"]);
    const DefaultIcon = getDefaultIcon(variant || 'default');
    return (_jsxs("div", Object.assign({ "data-slot": "alert", role: "alert", className: cn(alertVariants({ variant }), className) }, props, { children: [DefaultIcon && _jsx(DefaultIcon, {}), children] })));
}
export function AlertTitle(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("div", Object.assign({ "data-slot": "alert-title", className: cn('col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight', className) }, props)));
}
export function AlertDescription(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("div", Object.assign({ "data-slot": "alert-description", className: cn('text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed', className) }, props)));
}
